import urlToFile from '@quicktools/shared-components/utils/urlToFile';
import { imageDimensions } from '@quicktools/shared-components/utils/image/index';

import RemoveBackgroundApi from '../../services/backgroundRemoverApi/BackgroundRemoverApi';

export const handleRemoveBackground = async (imageUrl: string) => {
  const originalImage = await urlToFile(imageUrl);
  const { width, height } = await imageDimensions(URL.createObjectURL(originalImage));
  const uploadResponse = await RemoveBackgroundApi.uploadFile(originalImage);
  const uploadSources = { id: uploadResponse.id, width, height };
  const maskUrl = await RemoveBackgroundApi.getBgMask({
    images: [uploadSources],
  });

  return maskUrl[0].maskUrl;
};
